(() => {
  if (window.__twB006LinksBound) return;
  window.__twB006LinksBound = true;
  const rootSelector = '[data-tw-b006]';
  const controls = 'a,button,input,select,textarea,form,[role="button"],[data-play],.pf-mask,.pf-mask-iframe';
  const destination = element => element.getAttribute('data-href');
  function enhance() {
    document.querySelectorAll(rootSelector + ' [data-href]').forEach(element => {
      if (element.matches(controls)) return;
      const href = destination(element);
      if (!href || href.includes('サンプル.com')) return;
      const parent = element.parentElement?.closest('[data-href]');
      if (parent && destination(parent) === href) return;
      const nestedControls = [...element.querySelectorAll(controls)].filter(control => !control.closest('.tw-b006-source-link'));
      if (!nestedControls.length) {
        element.setAttribute('role', 'link');
        element.setAttribute('tabindex', '0');
      }
    });
  }
  function activate(event) {
    if (event.defaultPrevented || (event.type === 'click' && event.button !== 0)) return;
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    if (!(event.target instanceof Element) || event.target.closest(controls)) return;
    const element = event.target.closest('[data-href]');
    if (!element || !element.closest(rootSelector)) return;
    if (event.type === 'keydown' && (event.target !== element || element.getAttribute('role') !== 'link')) return;
    const href = destination(element);
    if (!href || href.includes('サンプル.com')) return;
    event.preventDefault();
    const target = event.ctrlKey || event.metaKey ? '_blank' : (element.getAttribute('data-target') || '_self');
    if (target === '_self') window.location.assign(href);
    else window.open(href, target, target === '_blank' ? 'noopener' : undefined);
  }
  document.addEventListener('click', activate);
  document.addEventListener('keydown', activate);
  document.addEventListener('shopify:section:load', enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
})();

